import React, { Suspense, useLayoutEffect, useState } from 'react';
import { isIOS } from 'react-device-detect';
import StartPage from './start/StartPage';
import Wizard from './Wizard';
import ce from '../data/ce-tree';
import de from '../data/de-tree';
import au from '../data/au-tree';

function App() {
  useLayoutEffect(() => {
    // specific fix for iOS devices - they don't respect height 100%
    // but they do respect height 100vh ¯\_(ツ)_/¯
    if (isIOS) {
      document.documentElement.classList.add('ios-full-height');
      document.body.classList.add('ios-full-height');
      document.getElementById('root').classList.add('ios-full-height');
    } else {
      document.documentElement.classList.add('full-height');
      document.body.classList.add('full-height');
      document.getElementById('root').classList.add('full-height');
    }
  }, []);

  const [trees] = useState({ ce, de, au });
  const [version, setVersion] = useState();
  const [isConfigured, setIsConfigured] = useState();

  /** Handles fake navigation to Start the Wizard */
  const navigateToWizard = (versionId) => {
    setVersion(versionId); // not sure if we need this
    setIsConfigured(true);
  };

  // if config for this round is OK render the questions,
  if (isConfigured) {
    return (
      <Suspense fallback={<Loading />}>
        <Wizard language={version} tree={trees[version]} />
      </Suspense>
    );
  }
  // otherwise, render start
  return (
    <Suspense fallback={<Loading />}>
      <StartPage onReady={navigateToWizard} />
    </Suspense>
  );
}

const Loading = () => (
  <div className="d-flex justify-content-center">Loading</div>
);

export default App;
